// src/hooks/usePreviewUrl.ts
import { useEffect, useState } from "react";

export const usePreviewUrl = (file: File | null) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => {
      URL.revokeObjectURL(url); // cleanup memory
    };
  }, [file]);

  return previewUrl;
};
